/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
// FormTabs.js
import React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab, Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tabsContainer: {
    flexGrow: 1,
    backgroundColor: "#f9f9f9",
    borderRadius: "24px",
    boxShadow:
      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
    paddingTop: theme.spacing(1),
  },
  tabs: {
    backgroundColor: "#f9f9f9",
    boxShadow: "none",
    borderRadius: "24px 24px 0px 0px",
  },
  tabRoot: {
    color: "#999", // default text color
    "&.Mui-selected": {
      color: "#133984", // selected tab text color
    },
  },
  indicator: {
    backgroundColor: "#133984", // indicator color
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`form-tabpanel-${index}`}
      aria-labelledby={`form-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `form-tab-${index}`,
    "aria-controls": `form-tabpanel-${index}`,
  };
}

const FormTabs = ({
  visibleCategories,
  activeTabIndex,
  onTabChange,
  children,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.tabsContainer}>
      <Tabs
        value={activeTabIndex}
        onChange={onTabChange}
        variant="scrollable"
        scrollButtons="auto"
        className={classes.tabs}
        TabIndicatorProps={{ className: classes.indicator }} // for custom indicator
      >
        {visibleCategories.map((formName, index) => (
          <Tab
            key={index}
            label={formName}
            {...a11yProps(index)}
            classes={{ root: classes.tabRoot }}
          />
        ))}
      </Tabs>

      {visibleCategories.map((formName, index) => (
        <TabPanel key={index} value={activeTabIndex} index={index}>
          {index === activeTabIndex && children}
        </TabPanel>
      ))}
    </div>
  );
};

FormTabs.propTypes = {
  visibleCategories: PropTypes.array.isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default FormTabs;
